module.exports = __webpack_public_path__ + "img/icon_weekly_menu_button.9e4db055.svg";